import { render, staticRenderFns } from "./ProductsMainInner.vue?vue&type=template&id=500ba3de&"
import script from "./ProductsMainInner.vue?vue&type=script&lang=js&"
export * from "./ProductsMainInner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports